import axios from "axios";
import _, { } from "lodash";
import moment from "moment";
import { setCartItemMeta } from "../../utils/cart";
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_PATH
  // `${process.env.VUE_APP_OUTSYSTEMCLOUD_API_BASE_PATH}/`;
export default {
  namespaced: true,
  state: {
    note: "",
    extraNote: "",
    isTablesLoading:false,
    isTimeSlotsLoading:false,
    tables: [],
    timeSlots: [],
    availablePaymentTypes: [],
    newOrder: sessionStorage.getItem("orderChunksExists"),
    orderId: 0,
    customerId: "",
    tableId: null,
    stickerId: "0",
    paymentTypeId: 1,
    securityCode: "",
    selectedTimeSlot: "",
    homeDelivery: false,
    tableManual: false,
    minSpent_w_charg_delivery: 0,
    cartIndex: 1,
    customer: {
      fullName: "",
      email: "",
      phone: "",
      vatNumber: "",
    },
    subCategoryCurrentItemModifier: [],
    cartValue: 0,
    totalPriceValue: 0,
    totalPriceValueWithCosts: 0,
    totalPriceValueWithCostsValue: 0,
    totalPriceValueWithLoyaltyDiscount: 0,
    tipAmount: 0,
    extraChargeAmount: 0,
    numberOfGuests: 0,
    homeDeliveryCosts: 0,
    discountInfo: {},
    priceToPayBeforeFeeIsGone: 0,
    // cartAdditions: 0,
    items: [],
    debounceCartItems: [],
    upsaleGroups: [],
    addedUpsaleItems: [],
    orderItemCount: 1,
    showUpselling: false,
    alreadyOrdered: false,
    isCartOverviewShow: false,
    isOrderTypeDineIn: localStorage.getItem('isOrderTypeDineIn') == "true" ? true : false,
    qrCodeImage: null,
    subCategoryCurrentItem: {},
    subCategoryCurrentModifiers: [],
    discount: {
      discountCodes: [],
      isDiscountCodeValid: false,
      discountAmount: 0,
    },
    comboDealAdditions: [],
    redeemLoyaltyPoints: false,
    loyaltyDiscount: 0,
    savedUpsell: [],
    selectedUpsellItems: [],
    automaticDiscount: false,
  },
  mutations: {
     updateSelectedUpsellItems(state, value) {
      state.selectedUpsellItems = value;    
      },
     updateAutomaticDiscount(state, value) {
      state.automaticDiscount = value
     },
     updateRedeemLoyaltyPoints(state, value) {
      state.redeemLoyaltyPoints = value;
     },
     updateIsTablesLoading(state, value) {
      state.isTablesLoading = value;
     },
     updateIsTimeSlotsLoading(state, value) {
      state.isTimeSlotsLoading = value;
     },
    updateSubCategoryCurrentItem(state, data) {
      state.subCategoryCurrentItem = data;
    },
    updateSubCategoryCurrentItemModifier(state, data) {
      state.subCategoryCurrentItemModifier = data;
     },
    addDebounceCartItems(state, data) {
      state.debounceCartItems.push(data)
    },
    clearDebounceCartItems(state) {
      state.debounceCartItems = []
    },
    addItem(state, data) {
      // add a random id to a cart item for easier handeling of these items
      data = setCartItemMeta(data);

      state.items.push(data);
      state.cartValue += data.price;
      if (data.OrderItemAdditions) {
        for (let i = 0; i < Object.keys(data.OrderItemAdditions).length; i++) {
          state.cartValue += data.OrderItemAdditions[i]["Addition"]["price"];
        }
      }
    },
    deleteItem(state, data) {
      let itemsClone = _.cloneDeep(state.items);
      itemsClone=_.map(itemsClone, el => {
        el.OrderItemAdditions = _.sortBy(el.OrderItemAdditions, [el => el.Addition.Id]);
        return el;
      });
      data.OrderItemAdditions = _.sortBy(data.OrderItemAdditions, [el => el.Addition.Id]);
      // Finding the ID of extra charge product if there is any with the modifier addition of the item to be removed
      let idOfExtraChargeProduct, indexOfExtraChargeProduct = null;
      data.OrderItemAdditions.forEach((element) => {
        if (element.Addition.extra_charge_product_id != "") {
          idOfExtraChargeProduct = element.Addition.extra_charge_product_id
        }
      })
      // Finding the last index of extra charge product 
      if (idOfExtraChargeProduct) {
        indexOfExtraChargeProduct = itemsClone.findLastIndex(el =>
          {
            if(el.Id == idOfExtraChargeProduct)
            return el.Id
        }
        )
      }
      function getAllIndexes(arr, val) {
      let indexes = [], i;
      for(i = 0; i < arr.length; i++)
      if (_.isEqual(arr[i] ,val))
        indexes.push(i);
        return indexes;
      }

      let indexes = getAllIndexes(itemsClone, data);
      let index = _.findLastIndex(itemsClone, (item) => {
        return _.isEqual(item ,data);
      });
      if (index >= 0) {
        if (idOfExtraChargeProduct) {
          let cart = [...(state.items)];
          cart.splice(indexOfExtraChargeProduct, 1);
          state.items.splice(index, 1);
          const temp = state.items.filter(value => cart.includes(value))
          state.items = [...temp]
        }
        else {
          if (indexes.length > 1) {
            let arr = itemsClone.filter(item => {
                  if (!_.isEqual(item, data)) {
                    return item
                  }
          })
            state.items = arr
          }
          else
          state.items.splice(index, 1);
      }
        state.cartValue -= data.price + state.cartAdditions;
      }
    },
    removeItem(state, data) {

      /** OrderItemAdditions were in random order, 
       * because of this items does not match in findLastIndex  */
      
      let itemsClone = _.cloneDeep(state.items);
      itemsClone=_.map(itemsClone, el => {
        el.OrderItemAdditions = _.sortBy(el.OrderItemAdditions, [el => el.Addition.Id]);
        return el;
      });
      data.OrderItemAdditions = _.sortBy(data.OrderItemAdditions, [el => el.Addition.Id]);

      // Finding the ID of extra charge product if there is any with the modifier addition of the item to be removed
      let idOfExtraChargeProduct, indexOfExtraChargeProduct = null;
      data.OrderItemAdditions.forEach((element) => {
        if (element.Addition.extra_charge_product_id != "") {
          idOfExtraChargeProduct = element.Addition.extra_charge_product_id
        }
      })
      // Finding the last index of extra charge product 
      if (idOfExtraChargeProduct) {
        indexOfExtraChargeProduct = itemsClone.findLastIndex(el =>
          {
            if(el.Id == idOfExtraChargeProduct)
            return el.Id
        }
        )
      }

      let index = _.findLastIndex(itemsClone, (item) => {
        return _.isEqual(item ,data);
      });

      if (index >= 0) {
        if (idOfExtraChargeProduct) {
          let cart = [...(state.items)];
          cart.splice(indexOfExtraChargeProduct, 1);
          state.items.splice(index, 1);
          const temp = state.items.filter(value => cart.includes(value))
          state.items = [...temp]
        }
        else {
          state.items.splice(index, 1);
        }
        state.cartValue -= data.price + state.cartAdditions;
      }
    },
    updateItemByCartId(state, data) {
      const index = _.findLastIndex(state.items, {
        _cartItemId: data._cartItemId,
      });

      // remove old price
      state.cartValue -= data.price + state.cartAdditions;

      // // set new cart item id
      // data = setCartItemMeta(data);

      // replace old data and keep same order in array
      state.items.splice(index, 1, data);

      // add price from product
      state.cartValue += data.price;

      // add price from modifiers
      state.cartValue += data.OrderItemAdditions.reduce(
        (acc, curr) => acc + curr.price,
        0
      );
    },
    /**
     * Ideally we should utilise the the above "removeItem" mutation but somehow
     * calling mutation recusively throwin error.
     * Having recursive way to remove multiple items is good here but, for now
     * a plural named "removeItems" mutation added which will remove multiple items from cart.
     *
     * @param {state} state
     * @param {data} item
     *
     * @return void
     */
    removeItems(state, data) {
      state.items.forEach(() => {
        let index = _.findLastIndex(state.items, data);
        if (index >= 0) {
          state.items.splice(index, 1);
          state.cartValue -= data.price + state.cartAdditions;
        }
      });
    },
    // addCartAdditions(state, value) {
    //   state.cartAdditions += value
    // },
    // subtractCartAdditions(state, value) {
    //   state.cartAdditions -= value
    // },
    emptyCart(state) {
      state.items = [];
    },
    updateTables(state, data) {
      state.tables = data;
    },
    updateTableId(state, tableId) {
      state.tableId = tableId;
      localStorage.setItem('tableId', tableId);
    },
    updateStickerId(state, stickerId) {
      state.stickerId = stickerId;
      localStorage.setItem('stickerId', stickerId);
    },
    updateTimeSlots(state, data) {
      state.timeSlots = data;
    },
    updateDiscountInfo(state, data) {
      state.discountInfo = data;
    },
    updateSelectedTimeSlot(state, timeSlot) {
      state.selectedTimeSlot = timeSlot;
    },
    updateCustomerId(state, Id) {
      state.customerId = Id;
    },
    updateOrderId(state, Id) {
      state.orderId = Id;
    },
    updateCustomer(state, data) {
      state.customer[data.field] = data.value;
    },
    updateNote(state, note) {
      state.note = note;
    },
    updateExtraNote(state, note) {
      state.extraNote = note;
    },
    updateAvailablePaymentTypes(state, data) {
      state.availablePaymentTypes = data;
    },
    updatePaymentTypeId(state, paymentTypeId) {
      state.paymentTypeId = paymentTypeId;
    },
    removeOrderChunks() {
      sessionStorage.removeItem("orderChunksExists");
    },
    updateSecurityCode(state, code) {
      state.securityCode = code;
    },
    updateTotalPriceValue(state, value) {
      state.totalPriceValue = value;
    },
    updateTotalPriceValueWithCost(state, value) {
      state.totalPriceValue = value;
    },
    updateTipAmount(state, value) {
      if (state.tipAmount + value >= 0) {
        state.tipAmount += value;
      }
    },
    updateExtraChargeAmount(state, value) {
      state.extraChargeAmount = value;
    },
    updateMinSpent_w_charg_delivery(state, value) {
      state.minSpent_w_charg_delivery = value;
    },
    updateNumberOfGuests(state, value) {
      if (state.numberOfGuests + value >= 0) {
        state.numberOfGuests += value;
      }
    },
    updatePriceToPayBeforeFeeIsGone(state, value) {
      state.priceToPayBeforeFeeIsGone = value;
    },
    updateIsDiscountCodeCorrect(state, value) {
      state.isDiscountCodeCorrect = value;
    },
    updateDiscountPercentageValue(state, value) {
      state.discountPercentageValue = value;
    },
    updateDiscountDecimalValue(state, value) {
      state.discountDecimalValue = value;
    },
    updateDiscountCode(state, value) {
      state.discountCode = value;
    },
    updateHomeDelivery(state, value) {
      state.homeDelivery = value;
    },
    updateTableManual(state, value) {
      state.tableManual = value;
    },
    updateHomeDeliveryCosts(state, value) {
      state.homeDeliveryCosts = value;
    },
    upsellGroups(state, data) {
      state.savedUpsell = data;
    },
    updateUpsaleGroups(state, data) {
      state.upsaleGroups = data;
    },
    updateAddedUpsaleItems(state, data) {
      state.addedUpsaleItems.push(data);
    },
    updateOrderItemCount(state, data) {
      state.orderItemCount = parseInt(data);
    },
    updateShowUpselling(state, data) {
      state.showUpselling = data;
    },
    updateIsCartOverviewShow(state, data) {
      state.isCartOverviewShow = data;
    },
    updateIsOrderTypeDineIn(state, data) {
      state.isOrderTypeDineIn = data;
      localStorage.setItem('isOrderTypeDineIn', data)
    },
    updateQrCodeImage(state, data) {
      state.qrCodeImage = data;
    },
    updateSubCategoryCurrentModifiers(state, item) {
      state.subCategoryCurrentModifiers = item;
    },
    addDiscountCodes(state, data) {
      // Add 'valid' discount codes
      // Temporary add one discount code as array.
      // Later it has to be pushed so multiple discount codes can be applied
      state.discount.discountCodes = [data];

      /**
       * For later, add valid discount codes to unique arrayO
       * */
      // let myArray = state.discount.discountCodes;
      // myArray.push(data);
      // let unique = Array.from(new Set(myArray.map(JSON.stringify))).map(JSON.parse); // Comparing string is more efficient than looping
      // state.discount.discountCodes = unique;
    },
    deleteDiscountCode(state, data) {
      // Delete one discount code
      state.discount.discountCodes = state.discount.discountCodes.filter(
        (code) => code.id != data.id
      );
    },
    toggleIsDiscountCodeValid(state, data) {
      // Toggle valid code to true
      // This is used by the alert message in the discount component
      state.discount.isDiscountCodeValid = data;
    },
    updateComboDealAdditions(state, data) {
      state.comboDealAdditions = data;
    },
  },
  actions: {
    UPDATE_ORDER({ commit, state, rootState, getters, rootGetters }, data) {
      const activateUpselling =
        data?.activateUpselling === undefined ? true : data.activateUpselling;
      let method,
        endpoint = "";

      if (
        (sessionStorage.getItem("orderChunksExists") === null &&
          !state.alreadyOrdered) ||
        (rootState.hasKiosk && data == undefined && !state.isCartOverviewShow)
      ) {
        sessionStorage.setItem("orderChunksExists", true);
        if (!rootState.hasKiosk) {
          state.alreadyOrdered = true;
        }
        method = "put";
        endpoint = "PatchOrder";
      } else {
        if (state.alreadyOrdered) {
          sessionStorage.setItem("orderChunksExists", true);
        }
        method = "put";
        endpoint = "PatchOrder";
      }

      if (data?.operation == "add") {
        for (let i = 1; i <= state.orderItemCount; i++) {
        commit("addItem", data.item);
        }
      } else if (data?.operation == "remove") {
        commit("removeItem", data.item);
      }
      else if (data?.operation == "delete") {
        commit("deleteItem", data.item)
      }

      return new Promise((resolve, reject) => {
        let tableId = getters.tableId

        if (rootGetters.menu.pos_mode == "table") {
          if (tableId == "" || tableId == null || tableId == 0) {
            let arr = [];
            arr.push("no table id found in cart.js");
            arr.push(this.customer);
            arr.push("tableid var", tableId);
            arr.push("tableid vuexx", state.tableId);
            arr.push("tableid local", getters.tableId);
            arr.push("sticketId local", getters.stickerId);
            arr.push("customer", state.customer);
            arr.push("menu", rootGetters.menu);
            let data = {
              MenuHash: rootGetters.menuHash,
              Dump: JSON.stringify(arr),
            };
            axios.post(
              `PostErrorDump`,
              data
            );
          }
        }
        let formData = {
          TableId: tableId,
          PaymentTypeId: state.paymentTypeId,
          MenuHASH: rootState.menuHash,
          OrderItems: getters.cartItemsRestructred,
          Customer: state.customer,
          sessionId: rootGetters.sessionId,
          SecurityToken: state.securityCode,
          note: rootState.menuRound ? `Round ${rootState.menuRound.round_number} ${state.extraNote}${state.extraNote && state.note && " - "}${
            state.note
          }` : `${state.extraNote}${state.extraNote && state.note && " - "}${
            state.note
          }`,
          tip_amount: state.tipAmount,
          number_of_guests: state.numberOfGuests,
          discountCode: state.discount.discountCodes[0]
            ? state.discount.discountCodes[0].code
            : "",
          is_order_type_dine_in: state.isOrderTypeDineIn,
          is_kiosk_order: rootState.hasKiosk,
          loyalty_discount: getters.loyaltyDiscount,
          round_number: rootState.menuRound? rootState.menuRound.round_number: null,
          round_id: rootState.menuRound? rootState.menuRound.id: null
        };
        if (state.tableManual != false) {
          formData.manual_table_entry = state.tableManual;
        }
        if (
          getters.totalPriceValue + state.tipAmount >=
          rootState.menu.min_spent
        ) {
          formData.extra_charge_amount = 0;
        } else {
          formData.extra_charge_amount = state.extraChargeAmount;
        }

        if (
          state.selectedTimeSlot &&
          (rootState.menu.timeslots_mode == "general" ||
            rootState.menu.timeslots_mode == "individual")
        ) {
          formData["deliveryDateTime"] = state.selectedTimeSlot == 'asap'
                                          ?`${moment().format('YYYY-MM-DD HH:mm:ss')}`
                                          : state.selectedTimeSlot;
        }
        if (rootState.menu.enable_delivery && rootState.Cart.homeDelivery) {
          // formData.tip_amount += state.homeDeliveryCosts;
          formData.delivery_cost = state.homeDeliveryCosts;
          formData.delivery_address1 =  rootState.menuRound.round_number ? rootState.menuRound.name : rootState.address;
          formData.delivery_address2 = rootState.busNumber;
          formData.delivery_zip = rootState.zip;
          formData.delivery_country = rootState.country;
        }
        
        axios({
          method: method,
          url: endpoint,
          data: formData,
        })
          .then((response) => {
            commit("updateCustomerId", response.data.OrderAPI.CustomerId);
            commit("updateOrderId", response.data.OrderAPI.orderId);
            commit("emptyCart");
            response.data.OrderAPI.OrderItems.forEach((element) => {
              let menuItem = element.MenuItem;
              menuItem["OrderItemAdditions"] = element.OrderItemAdditions;
              commit("addItem", menuItem);
              menuItem["OrderItemAdditions"].map((x, i) => {
                if (x.Addition.Id == 0) {
                  menuItem["OrderItemAdditions"].splice(i, 1);
                }
              });
            });
            /* If UpsaleGroups has Items  */
            if (data) {
              if (state.upsaleGroups.length) {
                commit("updateUpsaleGroups", state.upsaleGroups);

                let firstItem = _.find(rootGetters.menuItems, {
                  Id: data.item.Id,
                });
                let remainingItems = _.reject(rootGetters.menuItems, [
                  "Id",
                  data.item.Id,
                ]);

                let updatedMenuItems = [firstItem];
                state.upsaleGroups.forEach(function (group, groupIndex) {
                  /** Show We picked item for you label even if there's one group. */
                  if (
                    Object.values(group.groupMenuItems).length &&
                    data.operation == "add"
                  ) {
                    /** For the first label. */
                    if (groupIndex === 0) {
                      group.groupMenuItems[0]["upsell_item_available"] = true;
                    }
                    group["groupMenuItems"].forEach(function (item, index) {
                      if (index === 0) {
                        item["upselling_custom_group_name"] =
                          group["name_" + rootState.language];
                      }
                      commit("updateAddedUpsaleItems", data.item.Id);
                      // updatedMenuItems.push(item);
                      commit("updateUpselling", item, { root: true });
                      if (activateUpselling && data.operation !== "remove")
                        // state.showUpselling = true;
                        state.showUpselling = false;
                      // state.upsaleGroups = [];

                      if (state.isCartOverviewShow) {
                        commit(
                          "removeupsellingItems",
                          {},
                          {
                            root: true,
                          }
                        );
                      }
                      else {
                        state.showUpselling =
                          activateUpselling &&
                          true &&
                          data.operation !== "remove";
                      }
                      // state.upsaleGroups = [];
                    });
                  }
                });

                remainingItems.forEach(function (item) {
                  updatedMenuItems.push(item);
                });

                // commit("updateMenuItems", updatedMenuItems, { root: true });
              }
            }
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    GET_TABLES({ commit,state, rootState }) {
      // if (state.isTablesLoading) {
      //   console.log("isTablesLoading");
      //   return
      // }
      state.isTablesLoading = true;
      return new Promise((resolve, reject) => {
        axios
          .get(`GetTablesOrdering?MenuHash=${rootState.menuHash}`)
          .then((response) => {
            commit("updateTables", response.data);
            state.isTablesLoading = false;
            resolve(response);
          })
          .catch((error) => {
            state.isTablesLoading = false;
            reject(error);
          });
      });
    },

    GET_TIME_SLOTS({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        commit('updateIsTimeSlotsLoading', true);
        axios
          .get(`GetTimeSlotsOrdering?MenuHash=${rootState.menuHash}`)
          .then((response) => {
            commit("updateTimeSlots", response.data);
            commit('updateIsTimeSlotsLoading', false);
            resolve(response);
          })
          .catch((error) => {
            commit('updateIsTimeSlotsLoading', false);
            reject(error);
          });
      });
    },
    GET_MENU_ITEM_ORDERING({ rootState, commit, state }, menuItemId) {
      return new Promise((resolve, reject) => {
        axios
        .get(
          `GetMenuItemOrdering?MenuHash=${rootState.menuHash}&CategoryId=${rootState.categoryId}&MenuItemId=${menuItemId}`
          )
          .then((response) => {
            if (response.data.Discounts && typeof response.data.Discounts === 'object' && Object.keys(response.data.Discounts).length > 0 && !Array.isArray(response.data.Discounts)) {
              commit("updateAutomaticDiscount", response.data.Discounts);
            }
            else if(Array.isArray(response.data.Discounts) && response.data.Discounts.length === 0) {
              commit("updateAutomaticDiscount", false);
            }
            if (response.data.UpsellGroups.length) {
              const hasMaxSelectedAmountMoreThanOne = response.data.UpsellGroups.some(group => group.maxSelectedAmount > 1);
              if (hasMaxSelectedAmountMoreThanOne) {
                commit('upsellGroups', response.data.UpsellGroups);
              }
              commit("updateUpsaleGroups", response.data.UpsellGroups);
            } else {
              // commit("updateUpsaleGroups", []);
              commit("updateUpsaleGroups", state.savedUpsell);
            }
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    INITIATE_TRANSACTION(
      { state, rootState,getters, rootGetters, commit },
      paymentTypeId
    ) {
      // let stickerId = localStorage.getItem("stickerId")
      //   ? parseInt(localStorage.getItem("stickerId"))
      //   : 0;
      let stickerId=getters.stickerId
      return new Promise((resolve, reject) => {
        if (rootState.hasKiosk) {
          axios
            .get(
              `InitiateTransaction?sessionId=${rootGetters.sessionId}&orderId=${
                state.orderId
              }&paymentTypeId=${
                paymentTypeId.Id ? paymentTypeId.Id : paymentTypeId
              }&returnUrl=${rootState.appUrl}/${
                rootState.menuHash
              }/${stickerId}/order-details?sessionId=${
                rootGetters.sessionId
              }%26mode=kiosk`
            )
            .then((response) => {
              resolve(response);
              commit("updateQrCodeImage", response.data.paymentUrl);
            })
            .catch((error) => {
              reject(error);
              let arr = [];
              arr.push(error);
              arr.push(this.customer);
              arr.push("tableid", state.tableId);
              arr.push("customer", state.customer);
              arr.push("menu", state.menu);
              let data = {
                MenuHash: rootGetters.menuHash,
                Dump: JSON.stringify(arr),
              };
              axios.post(
                `PostErrorDump`,
                data
              );
            });
        } else {
          axios
            .get(
              `InitiateTransaction?sessionId=${rootGetters.sessionId}&orderId=${state.orderId}&paymentTypeId=${paymentTypeId}&returnUrl=${rootState.appUrl}/${rootState.menuHash}/${state.stickerId}/order-details?sessionId=${rootGetters.sessionId}`
            )
            .then((response) => {
              resolve(response);
              commit("updateQrCodeImage", response.data.paymentUrl);
            })
            .catch((error) => {
              reject(error);
              let arr = [];
              arr.push(error);
              arr.push(this.customer);
              arr.push("tableid", state.tableId);
              arr.push("customer", state.customer);
              arr.push("menu", state.menu);
              let data = {
                MenuHash: rootGetters.menuHash,
                Dump: JSON.stringify(arr),
              };
              axios.post(
                `PostErrorDump`,
                data
              );
            });
        }
      });
    },
    VALIDATE_DISCOUNT_CODE({ commit, rootState }, discountCode) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            `ValidateDiscountCode?MenuHash=${rootState.menuHash}&Code=${discountCode}`
          )
          .then((response) => {
            if (response.data.length != 0) {
              // Add the discount code to valid discount codes
              // Used during checkout in the discountslist component
              commit("addDiscountCodes", response.data[0]);
              commit("toggleIsDiscountCodeValid", true); // Show discount-alert 'valid code' ~true
            } else {
              commit("toggleIsDiscountCodeValid", false); // Show discount-alert 'invalid code' ~false
            }
          })
          .catch((error) => {
            commit("loadingItems", false);
            reject(error);
          });
      });
    },
  },
  getters: {
    loyaltyDiscount: (state, rootGetters, getters) => {
      let loyalty_discount = 0;
      if (state.redeemLoyaltyPoints) {
        if (getters.loyaltyPoints / 100 >= rootGetters.totalPriceValueWithCostsValue) {
          loyalty_discount = rootGetters.totalPriceValueWithCostsValue
        }
        else if (rootGetters.loyaltyPoints / 100 < rootGetters.totalPriceValueWithCostsValue) {
          loyalty_discount = getters.loyaltyPoints / 100
        }
      }
      state.loyaltyDiscount = loyalty_discount
      return state.loyaltyDiscount
    },
    isTablesLoading: (state) => state.isTablesLoading,
    isTimeSlotsLoading: (state) => state.isTimeSlotsLoading,
    cartItems: (state) => state.items,
    debounceCartItems: (state) => state.debounceCartItems,
    cartItemsRestructred: (state) => {
      let orderItems = [];
      for (let i = 0; i < state.items.length; i++) {
        /** Restructing orderModifiers as the backend expects */
        let orderItemAdditions = [];
        _.forEach(state.items[i]["OrderItemAdditions"], function (value) {
          orderItemAdditions.push({
            AdditionGroupId: value["Addition"]["AdditionGroupId"],
            AdditionId: value["Addition"]["Id"],
            combo_deal_item_id: value["Addition"]["combo_deal_item_id"],
          });
        });
        /** Fuliflling backend's expectations */
        orderItems.push({
          MenuItemId: state.items[i]["Id"],
          OrderItemAdditions: orderItemAdditions,
        });
      }
      return orderItems;
    },
    cartValue: (state) => {
      let totalPrice = 0;
      state.items.forEach((value) => {
        totalPrice += value.price;
        if (value.OrderItemAdditions) {
          value.OrderItemAdditions.forEach((itemAdditions) => {
            totalPrice += itemAdditions["Addition"]["price"];
          });
        }
      });
      return (state.cartValue = totalPrice);
    },
    tables: (state) => state.tables,
    timeSlots: (state) => state.timeSlots,
    selectedTimeSlot: (state) => state.selectedTimeSlot,
    orderId: (state) => state.orderId,
    customerId: (state) => state.customerId,
    tableId: (state) => {
      if (!state.tableId && localStorage.getItem("tableId")) {
        let localVal = localStorage.getItem("tableId");
        state.tableId = localVal==="null"?null:parseInt(localVal);
      }
      return state.tableId;
    },
    stickerId: (state) => {
      if (!state.stickerId && localStorage.getItem('stickerId')) {
        state.stickerId = parseInt(localStorage.getItem("stickerId"));
      }
      return state.stickerId;
    },
    customer: (state) => state.customer,
    note: (state) => state.note,
    extraNote: (state) => state.extraNote,
    availablePaymentTypes: (state) =>
      _.orderBy(state.availablePaymentTypes, ["has_priority"], ["desc"]),
    securityCode: (state) => state.securityCode,
    isListDisplayed: (state) => state.isListDisplayed,
    totalPriceValue: (state) => {
      let totalPrice = 0;
      state.items.forEach((value) => {
        totalPrice += value.price;
        if (value.OrderItemAdditions) {
          value.OrderItemAdditions.forEach((itemAdditions) => {
          /** Addition may have multiple Additions in comboDeals */
            if(Array.isArray(itemAdditions.Addition)){
              return totalPrice+=itemAdditions.Addition.reduce((ac,cu)=>{ac+=cu.price},0);
            }
            return totalPrice += itemAdditions.Addition.price;
          });
        }
      });
      return (state.totalPriceValue = totalPrice.toFixed(2));
    },
    totalPriceValueWithCosts: (state, getters, rootState, rootGetters) => {
      // Calculate the total price. Used during checkout process
      let totalPrice = 0;
      // 1. Add itemprice per item in cart
      state.items.forEach((value) => {
        totalPrice += value.price;
        if (value.OrderItemAdditions) {
          value.OrderItemAdditions.forEach((itemAdditions) => {
            totalPrice += itemAdditions["Addition"]["price"];
          });
        }
      });
      // 2. Add tipping
      if (rootState.menu.enable_tipping) {
        totalPrice += state.tipAmount;
      }
      // 3. Add extra cost if min order amount is not reached
      if (totalPrice < rootState.menu.min_spent_amount_w_charg) {
        totalPrice += rootState.menu.charge_amount_when_min_spent;
      }
      // 4. Substract discount
      if (state.discount.discountCodes[0]) {
        if (
          state.discount.discountCodes[0].is_active &&
          state.items.length >= state.discount.discountCodes[0].minimum_items &&
          state.totalPriceValue + state.tipAmount >=
            state.discount.discountCodes[0].minimum_spent
        ) {
          totalPrice -= getters.discountAmount;
          if (totalPrice - parseInt(state.tipAmount) < 0) {
            totalPrice += getters.discountAmount;
          }
        }
      }
      // 5. Add delivery charges
      if (
        state.homeDelivery && state.minSpent_w_charg_delivery
          ? parseInt(state.totalPriceValue) + parseInt(state.tipAmount) <
            state.minSpent_w_charg_delivery
          : true
      ) {
        if (state.homeDelivery) totalPrice += state.homeDeliveryCosts;
        totalPrice;
      }
      // 6. Redeem the loyalty points 
      if (state.redeemLoyaltyPoints && rootState.comoPayment) {
        totalPrice -= rootGetters.loyaltyPoints/100
        if (totalPrice <= 0) {
          totalPrice = 0
        }
      }
      // Finally return the total price
      return (state.totalPriceValueWithCosts = totalPrice.toFixed(2));
    },
    totalPriceValueWithLoyaltyDiscount: (state, getters, rootState, rootGetters) => {
      // Calculate the total price. Used during checkout process
      let totalPrice = 0;
      // 1. Add itemprice per item in cart
      state.items.forEach((value) => {
        totalPrice += value.price;
        if (value.OrderItemAdditions) {
          value.OrderItemAdditions.forEach((itemAdditions) => {
            totalPrice += itemAdditions["Addition"]["price"];
          });
        }
      });
      // 2. Add tipping
      if (rootState.menu.enable_tipping) {
        totalPrice += state.tipAmount;
      }
      // 3. Add extra cost if min order amount is not reached
      if (totalPrice < rootState.menu.min_spent_amount_w_charg) {
        totalPrice += rootState.menu.charge_amount_when_min_spent;
      }
      // 4. Substract discount
      if (state.discount.discountCodes[0]) {
        if (
          state.discount.discountCodes[0].is_active &&
          state.items.length >= state.discount.discountCodes[0].minimum_items &&
          state.totalPriceValue + state.tipAmount >=
            state.discount.discountCodes[0].minimum_spent
        ) {
          totalPrice -= getters.discountAmount;
          if (totalPrice - parseInt(state.tipAmount) < 0) {
            totalPrice += getters.discountAmount;
          }
        }
      }
      // 5. Add delivery charges
      if (
        state.homeDelivery && state.minSpent_w_charg_delivery
          ? parseInt(state.totalPriceValue) + parseInt(state.tipAmount) <
            state.minSpent_w_charg_delivery
          : true
      ) {
        if (state.homeDelivery) totalPrice += state.homeDeliveryCosts;
        totalPrice;
      }
      // 6. Redeem the loyalty points 
      if (state.redeemLoyaltyPoints == true ) {
        totalPrice -= rootGetters.loyaltyPoints/100
        if (totalPrice <= 0) {
          totalPrice = 0
        }
      }
      // Finally return the total price
      return (state.totalPriceValueWithLoyaltyDiscount = totalPrice.toFixed(2));
    },
    totalPriceValueWithCostsValue: (state, getters, rootState) => {
      let totalPrice = 0;
      state.items.forEach((value) => {
        totalPrice += value.price;
        if (value.OrderItemAdditions) {
          value.OrderItemAdditions.forEach((itemAdditions) => {
            totalPrice += itemAdditions["Addition"]["price"];
          });
        }
      });
      if (rootState.menu.enable_tipping) {
        totalPrice += state.tipAmount;
      }
      if (totalPrice < rootState.menu.min_spent_amount_w_charg) {
        totalPrice += rootState.menu.charge_amount_when_min_spent;
      }
      if (state.discount.discountCodes[0]) {
        if (
          state.discount.discountCodes[0].is_active &&
          state.items.length >= state.discount.discountCodes[0].minimum_items &&
          state.totalPriceValue + state.tipAmount >=
            state.discount.discountCodes[0].minimum_spent
        ) {
          totalPrice -= getters.discountAmount;
        }
      }
      if (
        state.homeDelivery && state.minSpent_w_charg_delivery
          ? parseInt(state.totalPriceValue) + parseInt(state.tipAmount) <
            state.minSpent_w_charg_delivery
          : true
      ) {
        totalPrice += state.homeDeliveryCosts;
      }
      return (state.totalPriceValueWithCostsValue = totalPrice.toFixed(2));
    },
    tipAmount: (state) => state.tipAmount,
    extraChargeAmount: (state) => state.extraChargeAmount,
    numberOfGuests: (state) => state.numberOfGuests,
    discountAmount: (state) => {
      if (!state.discount.discountCodes[0]) {
        return state.discountAmount;
      }

      if (state.discount.discountCodes[0].type === "Percentage") {
        //Check if we don't reach the maximum amount discount, else give the maximum border
        state.discountAmount =
          (state.totalPriceValue * state.discount.discountCodes[0].value) / 100;

        if (
          state.discountAmount >=
            state.discount.discountCodes[0].max_disc_amount_percentage &&
          state.discount.discountCodes[0].max_disc_amount_percentage != 0
        ) {
          state.discountAmount =
            state.discount.discountCodes[0].max_disc_amount_percentage;
        }
      }

      if (state.discount.discountCodes[0].type !== "Percentage") {
        state.discountAmount = state.discount.discountCodes[0].value;
      }
      return state.discountAmount;
    },
    homeDelivery: (state) => state.homeDelivery,
    tableManual: (state) => state.tableManual,
    homeDeliveryCosts: (state) => state.homeDeliveryCosts,
    priceToPayBeforeFeeIsGone: (state) => state.priceToPayBeforeFeeIsGone,
    minSpent_w_charg_delivery: (state) => state.minSpent_w_charg_delivery,
    addedUpsaleItems: (state) => state.addedUpsaleItems,
    items: (state) => state.items,
    orderItemCount: (state) => state.orderItemCount,
    showUpselling: (state) => state.showUpselling,
    upsaleGroups: (state) => state.upsaleGroups,
    isCartOverviewShow: (state) => state.isCartOverviewShow,
    isOrderTypeDineIn: (state) => state.isOrderTypeDineIn,
    qrCodeImage: (state) => state.qrCodeImage,
    subCategoryCurrentItem: (state) => state.subCategoryCurrentItem,
    subCategoryCurrentModifiers: (state) => state.subCategoryCurrentModifiers,
    discount: (state) => state.discount,
    comboDealAdditions: (state) => state.comboDealAdditions,
    subCategoryCurrentItemModifier: (state) => state.subCategoryCurrentItemModifier,
    alreadyOrdered: (state) => state.alreadyOrdered,
    redeemLoyaltyPoints: (state) => state.redeemLoyaltyPoints,
    selectedUpsellItems: (state) => state.selectedUpsellItems,
    automaticDiscount: (state) => state.automaticDiscount,
  },
};
